export const FavoritesList = [
    {
        title: "SPOT",
        shortTitle: "Spotify",
        cost: "$310,40",
        profitLoss: "-1,10% ",
        src: "/img/Spot.svg",
    },
    {
        title: "ABNB",
        shortTitle: "Airbnb",
        cost: "$310,40",
        profitLoss: "-1,10% ",
        src: "/img/Airbnb.svg",
    },
    {
        title: "SHOP",
        shortTitle: "Shopify",
        cost: "$310,40",
        profitLoss: "-1,10% ",
        src: "/img/shopify.svg",
    },
];

export const companyTickers = [
    { name: "Apple", ticker: 'AAPL' },
    { name: 'Microsoft', ticker: 'MSFT' }
]